<template>
  <div class="pt-3 background-img">
    <v-overlay v-model="loading">
      <v-progress-circular indeterminate color="#FFF9C4" :size="80" :width="7"></v-progress-circular>
    </v-overlay>
    <v-row class="pass-exam-row search-exam-header-row">
      <v-col cols="auto" md="auto" lg="auto" class="py-2">
        <v-btn depressed small fab color="rgb(94, 174, 235)" @click="$router.push({ name: 'login' })">
          <!-- back button -->
          <v-icon color="#ffffff">mdi-chevron-double-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="9" md="auto" lg="auto" class="mt-1 px-4 py-2 search-exam-header-block">
        <b class="search-exam-header">ค้นหาข้อมูลประกาศนียบัตรผู้ปฏิบัติการจากระบบลงทะเบียน</b>
      </v-col>
    </v-row>
    <v-row no-gutters class="standard-row mt-4 mb-7" v-resize="onResize">
      <div style="padding: 0% 2.4% 0 2.7%; width: 100%">
        <v-card class="mx-auto card-search" max-width="90%">
          <template>
            <v-form ref="form_2">
              <v-container style="padding: 50px">
                <v-row class="standard-row">
                  <v-col cols="12" md="4" align="center">
                    <p>เลขบัตรประชาชน</p>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-text-field color="#2a9d8f" dense outlined hide-details clearable class="input-card-search"
                      v-model="id_card_num_birth_date" @click:clear="id_card_num_birth_date = null;"
                      :onkeypress="`return ((event.charCode >= 48 && event.charCode <= 57) && &quot;${id_card_num_birth_date}&quot;.length<13)`"
                      :rules="[
                        ...rules.required,
                        ...rules.number,
                        ...rules.textLength13,]">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="standard-row">
                  <v-col cols="12" md="4" align="center">
                    <p>คำนำหน้า</p>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-combobox color="#2a9d8f" dense outlined rounded clearable hide-details
                      append-icon="mdi-chevron-down" :items="list_title_name"
                      class="input-box-card-search input-card-search" v-model="selected_title_name"></v-combobox>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-text-field v-if="selected_title_name === 'อื่นๆ'" color="#2a9d8f" dense outlined hide-details
                      clearable class="input-card-search" v-model="title_name" @click:clear="title_name = null;" :rules="[
                      ...rules.required,
                      ...rules.noDigits,
                    ]">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="standard-row">
                  <v-col cols="12" md="4" align="center">
                    <p>ชื่อ</p>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-text-field color="#2a9d8f" dense outlined hide-details clearable class="input-card-search"
                      v-model="first_name" @click:clear="first_name = null;" :rules="[
                      ...rules.noDigits,
                      ...rules.noSpecialChars,
                    ]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="standard-row">
                  <v-col cols="12" md="4" align="center">
                    <p>นามสกุล</p>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-text-field color="#2a9d8f" dense outlined hide-details clearable class="input-card-search"
                      v-model="last_name" @click:clear="last_name = null;" :rules="[
                      ...rules.noDigits,
                      ...rules.noSpecialChars,
                    ]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="standard-row">
                  <v-col cols="12" md="4" align="center">
                    <p>วันเริ่มประกาศนียบัตร</p>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-menu :close-on-content-click="false" offset-y v-model="start_date_menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field color="#2a9d8f" dense outlined rounded hide-details readonly clearable v-on="on"
                          v-bind="attrs" @click:clear="start_date = null;" :value="start_date | shortdate"
                          class="input-card-search pass-exam-inputbox pass-exam-start-input"
                          id="start_date"></v-text-field>
                      </template>
                      <v-date-picker locale="th" color="#2a9d8f" :max="end_date" v-model="start_date" @input="start_date_menu = false;"
                        style="width: 100%; height: 100%;" class="pass-exam-calendar"></v-date-picker>
                    </v-menu>
                  </v-col>
                  </v-row>
                <v-row class="standard-row">
                  <v-col cols="12" md="4" align="center">
                    <p>วันหมดอายุประกาศนียบัตร</p>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <v-menu :close-on-content-click="false" offset-y v-model="end_date_menu">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field color="#2a9d8f" dense hide-details outlined readonly clearable v-on="on"
                          v-bind="attrs" @click:clear="end_date = null;" :value="end_date | shortdate"
                          class="input-card-search pass-exam-inputbox pass-exam-start-input"
                          id="end_date"></v-text-field>
                      </template>
                      <v-date-picker locale="th" color="#2a9d8f" :min="start_date" v-model="end_date"
                        @input="end_date_menu = false;" style="width: 100%; height: 100%;" class="pass-exam-calendar"></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row class="standard-row">
                  <v-col align="center">
                    <v-btn class="search-btn" color="#2a9d8f" @click="getCertificatedStatus">
                      <v-icon class="text-white" color="#CFDB31" left> mdi-magnify </v-icon> ค้นหาข้อมูล
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>
        </v-card>
        <div v-if="card_certificated_status" style="margin-top: 20px" class="CardTrainingStatus">
          <template>
            <v-card class="mx-auto card-search-sm" max-width="90%">
              <v-card-title class="card-header">
                <v-icon color="white" style="padding-right: 5px;">mdi-account-check</v-icon>
                <span class="text-white">ข้อมูลประกาศนียบัตร</span>
              </v-card-title>
              <template v-if="certificated_status && certificated_status.length">
                <v-card-text v-for="(data, index) in certificated_status" :key="index" class="card-text">
                  <v-row style="padding: 20px;">
                    <v-col cols="12" sm="12" md="2" lg="2" align="center">
                      <v-img class="certificated-image" v-if="data.image_path" :src="data.image_path"></v-img>
                      <v-img class="certificated-image" v-else src="../assets/noname.jpg"></v-img>
                    </v-col>
                    <v-col cols="12" sm="12" md="10" lg="10">
                      <v-row no-gutters class="standard-row" style="text-align: left;">
                        <v-col cols="12" sm="5" md="12" lg="2" class="pl-md-2">
                          <p class="head-topic-certificated">ชื่อ - นามสกุล :</p>
                        </v-col>
                        <v-col cols="12" sm="7" md="12" lg="7" class="pl-md-2">
                          <p class="topic-certificated"> {{ data.title_name }} {{ data.first_name }} {{ data.last_name }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="standard-row" style="text-align: left;">
                        <v-col cols="12" sm="5" md="12" lg="2" class="pl-md-2">
                          <p class="head-topic-certificated">ระดับ :</p>
                        </v-col>
                        <v-col cols="12" sm="7" md="12" lg="7" class="pl-md-2">
                          <p class="topic-certificated">{{ data.level }}</p>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="standard-row" style="text-align: left;">
                        <v-col cols="12" sm="5" md="12" lg="2" class="pl-md-2">
                           <p class="head-topic-certificated">เลขที่ :</p>
                        </v-col>
                        <v-col cols="12" sm="7" md="12" lg="7" class="pl-md-2">
                           <p class="topic-certificated">{{ data.certificated_number }}</p>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="standard-row" style="text-align: left;">
                        <v-col cols="12" sm="5" md="12" lg="2" class="pl-md-2">
                          <p class="head-topic-certificated">อนุมัติให้วันที่ :</p>
                        </v-col>
                        <v-col cols="12" sm="7" md="12" lg="7" class="pl-md-2">
                          <p class="topic-certificated">{{ data.certificated_date }} จนถึง {{ data.expire_date || '-' }}</p>
                        </v-col>
                        <v-col>
                        </v-col>
                        <!-- <v-col cols="12" sm="12" md="12" lg="12"  class="pl-md-2">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-btn depressed small fab color="#2a9d8f" v-on="on" :href="data.new_certificate || data.old_certificate">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" color="#ffff"
                                  fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                  <path
                                    d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                  <path
                                    d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                </svg>
                              </v-btn>
                            </template>
                          <span class="font-theme">ดาวน์โหลดใบประกาศนียบัตรผู้ปฏิบัติการ</span>
                          </v-tooltip>
                        </v-col> -->
                      </v-row>
                    </v-col>
                  </v-row>

                </v-card-text>
              </template>
              <template v-else>
                <v-card-text class="card-text">
                  <p align="center" style="padding: 10px;">
                    <v-icon color="red" left> mdi mdi-alert-circle-outline </v-icon> <span>ไม่พบข้อมูล</span>
                  </p>
                </v-card-text>
              </template>
            </v-card>
           
                <!-- <v-container>
                  <v-card class="mt-4" v-if="pdfData">
                    <iframe :src="pdfData" width="100%"></iframe>
                  </v-card>
                </v-container> -->
            </template>
        </div>
          <div v-if="Object.values(pdfDataCardNum).length" style="margin-top: 20px;" class="CardTrainingStatus">
            <template>
              <v-card class="mx-auto card-search-sm" max-width="90%" min-height="200px">
                <v-card-title class="card-header d-flex justify-space-between align-center">
                  <div class="d-flex align-center">
                    <v-icon color="white" style="padding-right: 5px;">mdi-account-check</v-icon>
                    ข้อมูลบัตรประจำตัวผู้ปฏิบัติการ
                  </div>
                  <v-btn v-if="pdfData && !isAndroid" color="primary" dark @click="previewPdf">
                    <v-icon rigth>mdi-file-eye</v-icon>
                    ดูเอกสาร
                  </v-btn>
                </v-card-title>
                <!-- PDF Dialog -->
                  <v-dialog v-model="pdfDialog" max-width="900px" persistent>
                    <v-card>
                      <v-card-title class="dialog-pdf">
                        บัตรประจำตัวผู้ปฏิบัติการ
                        <v-spacer></v-spacer>
                        <v-btn icon @click="pdfDialog = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-card-text style="height: 80vh; padding: 0;">
                        <iframe
                          v-if="pdfData"
                          :src="pdfData"
                          width="100%"
                          height="100%"
                          style="border: none;"
                        ></iframe>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                <template>
                  <div v-if="idCardProgress" class="text-center mt-10" style=" font-size: 18px;">
                        กำลังดำเนินการออกบัตรประจำตัว...
                  </div>
                  <v-card v-else style="position: relative;">
                    <v-overlay v-model="loadingPDF" absolute>
                      <v-progress-circular indeterminate color="#FFF9C4" :size="80" :width="7"></v-progress-circular>
                    </v-overlay>
                      <!-- <div v-if="isMobile"> -->
                        <v-col cols="12" class="flex-layout flex-layout-column">
                          <div class="card-row">
                          <div class="card-wrapper">
                          <v-card class="card-scale front-card card-pdf-v2 pdf-v2-sec1 pa-3 overflow-hidden" width="317" height="204"  elevation="0"> <!-- width="317" height="204"-->
                            <img class="card-pdf-bg" src="../assets/new-logo.png" width="64%" height="97%" alt="">
                            <v-row class="sec1-description">
                              <v-col cols="4">
                                <!-- <img src="../assets/noname.jpg" width="90%" height="60%" alt="img-user"> -->
                                <v-img width="90%"  height="110px"  v-if="pdfData && pdfDataCardNum?.image_path" :src="pdfDataCardNum.image_path"></v-img>
                                <v-img  width="90%"  height="110px" v-else src="../assets/noname.jpg"></v-img>
                              </v-col>
                              <v-col cols="8" style="margin-left: -18px;">
                                <p class="pdf-no">เลขที่ <span>{{ pdfDataCardNum.identity_card_number }}</span></p>
                                <p>ชื่อ <span>{{ pdfDataCardNum.full_name }}</span></p> 
                                <p>เลขประจำตัวประชาชน <span>{{ pdfDataCardNum.id_card_num }}</span></p>
                                <p style="width: 115%;">ระดับผู้ปฏิบัติการ <span>{{ pdfDataCardNum.level }}</span></p>
                                <p>เลขที่ประกาศนียบัตร <span>{{ pdfDataCardNum.certificate_number }}</span></p>
                                <div class="flex-layout flex-layout-between">
                                  <p>วันออกบัตร <span>{{ pdfDataCardNum.certificated_date }}</span></p>
                                  <p>วันหมดอายุ <span>{{ pdfDataCardNum.expire_date }}</span></p>
                                </div>
                                <div  v-if="pdfData" class="flex-layout-licence">
                                    <img class="flex-layout-licence-signature" src="../assets/sign_niems_2568.png" alt="img-signature">
                                  <p class="flex-layout-licence-name">นายพิเชษฐ์ หนองช้าง</p>
                                  <p class="flex-layout-licence-position">เลขาธิการสถาบันการแพทย์ฉุกเฉินแห่งชาติ</p>
                                  <p class="flex-layout-licence-authority">ผู้ออกบัตร</p>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card>
                          </div>
                           <!-- <div class="card-wrapper"> -->
                            <!-- <v-card class="card-scale back-card card-pdf-v2 pdf-v2-sec1 pa-3 overflow-hidden" width="317" height="204" elevation="0">
                                  <v-row class="sec1-description">
                                      <v-col cols="12">
                                          <p>
                                            <img src="../assets/new-logo.png" width="30%" height="30%" alt="img-user">
                                          </p>
                                          <p>
                                            ผู้ถือบัตรเป็นผู้มีอำนาจหน้าที่ ขอบเขต ความรับผิดชอบ หรือข้อจำกัด
                                            ในการปฏิบัติการฉุกเฉินตามพระราชบัญญัติการแพทย์ฉุกเฉิน พ.ศ. ๒๕๕๑
                                            โดยจะต้องปฏิบัติหน้าที่ในหน่วยปฏิบัติการที่มีสถานะความเป็นหน่วย
                                            ปฏิบัติการยังคงอยู่ หรือสถานพยาบาลที่ดำเนินการปฏิบัติการฉุกเฉิน

                                            ในกรณีที่ผู้ปฏิบัติการใดที่มิได้สังกัดหน่วยปฏิบัติการหรือสถานพยาบาล
                                            ในห้วงระยะเวลาที่บัตรประจำตัวผู้ปฏิบัติการยังมีอายุอยู่ ผู้ปฏิบัติการนั้น
                                            ไม่สามารถปฏิบัติการฉุกเฉินได้ในช่วงระยะเวลาดังกล่าว
                                          </p>
                                      </v-col>
                                  </v-row>
                              </v-card> -->
                          <!-- </div> -->
                          </div>
                        </v-col>
                      <!-- </div>
                      <iframe
                        v-else-if="pdfUrl"
                        :src="pdfUrl"
                        style="width:100%; height:800px;"
                      ></iframe> -->
                    </v-card>
                </template>
              </v-card>
            </template>
          </div>
        <div aria-hidden="true" style="
          position: fixed;
          top: 0;
          left: 0;
          opacity: 0;
          z-index: -1;
          pointer-events: none;
          transform: scale(1);
        ">
          <template>
            <v-card class="mx-auto card-search-sm" max-width="90%">
              <v-card-title class="card-header">
                <v-icon color="white" style="padding-right: 5px;">mdi-account-check</v-icon>
                ข้อบูลบัตรประจำตัวผู้ปฏิบัติการ
              </v-card-title>
              <v-row ref="pdfContent" class="pdf-v2" align="center" justify="center" no-gutters>
                <v-col cols="12" class="flex-layout flex-layout-column">
                  <v-card class="card-pdf-v2 pdf-v2-sec1" width="320" min-height="200" elevation="0">
                    <img class="card-pdf-bg" src="../assets/new-logo.png" width="64%" height="97%" alt="">
                    <v-row class="sec1-description">
                      <v-col cols="4">
                        <img src="../assets/noname.jpg" width="100%" height="100%" alt="img-user">
                      </v-col>
                      <v-col cols="8" style="padding-left: 0;">
                        <p class="pdf-no">เลขที่ <span>{{ pdfDataCardNum.identity_card_number }}</span></p>
                        <p>ชื่อ <span>{{ pdfDataCardNum.full_name }}</span></p>
                        <p>เลขประจำตัวประชาชน <span>{{ pdfDataCardNum.id_card_num }}</span></p>
                        <p style="width: 115%;">ระดับผู้ปฏิบัติการ <span>{{ pdfDataCardNum.level }}</span></p>
                        <p>เลขที่ประกาศนียบัตร <span>{{ pdfDataCardNum.certificate_number }}</span></p>
                        <div class="flex-layout-licence">
                          <p>วันออกบัตร <span>{{ pdfDataCardNum.certificated_date }}</span></p>
                          <p>วันหมดอายุ <span>{{ pdfDataCardNum.expire_date }}</span></p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </div>
      </div>
      <div>
      </div>
    </v-row>
  </div>
</template>
<script>
import { EventBus } from '../EventBus';
import html2pdf from "html2pdf.js";
//import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  //components: {
  //  VuePdfEmbed,
  //},
  data: () => ({
    loading: false,
    list_title_name: [],
    windowSize: { x: 0, y: 0 },
    rules: {
      required: [(v) => !!v],
      number: [(v) => !isNaN(v) && /^[0-9]*$/.test(v)],
      textLength13: [(v) => v && v.length == 13],
      textLength8: [(v) => v && v.length == 8],
      noDigits: [(v) => /^[^0-9]*$/.test(v)],
      noSpecialChars: [(v) => /^[A-Za-zก-ฮะ-๙]*$/.test(v)],
    },
    start_date_menu: false,
    end_date_menu: false,
    start_date: '',
    end_date: '',
    showDescription: false,
    id_card_num_birth_date: "",
    title_name: "",
    selected_title_name: "",
    first_name: "",
    last_name: "",
    date_password: "",
    certificated_status: {},
    card_certificated_status: false,
    certificatedIdCardData: null,
    pdfData: null,
    pdfUrl: null,
    pdfDataCardNum: {},
    loadingPDF: false,
    windowWidth: window.innerWidth,
    idCardProgress: false,
    pdfDialog: false,
    isAndroid: false
  }),
  mounted() {
    this.getLisTitleName()
    this.urlParam = this.$route.params.id_card_num_birth_date;
    if (this.urlParam) {
        this.id_card_num_birth_date = this.urlParam;
        this.getCertificatedStatus();
    }
    window.addEventListener('resize', this.updateWidth)
    this.checkIfAndroid();
  },
  computed: {
     pdfWidth() {
      if (this.windowWidth < 786) {
        return 800 
      } else {
        return 1300
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    }
  },
  methods: {
    checkIfAndroid() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const checkResult = /android/i.test(userAgent);
      if (checkResult) {
        this.isAndroid = true;
      }
    },
    updateWidth() {
      this.windowWidth = window.innerWidth
    },
    async generatePDF() {
      this.loadingPDF = true;
      const element = this.$refs.pdfContent;
      const options = {
        margin: 50,
        html2canvas: { scale: 5 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        // output: "blob",
      };

      // html2pdf().set(options).from(element).outputPdf("blob").then((blob) => {
      //   this.pdfUrl = URL.createObjectURL(blob);
      // });
      const pdfBlob = await html2pdf().set(options).from(element).output('blob');
      this.pdfUrl = URL.createObjectURL(pdfBlob);
      this.loadingPDF = false;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth }
    },
    async getCertificatedStatus() {
      try {
        this.loading = true;
        if (!this.id_card_num_birth_date) {
          this.card_certificated_status = false;
          EventBus.$emit('alert-warning', 'กรอกข้อมูลเลขบัตรประชาชนให้ครบถ้วน');
          return;
        }
        const isValid = await this.$refs.form_2.validate();
        if (isValid || this.urlParam) {
          const axios = this.axios;
          const [response] = await Promise.all([
            axios.get(`/public/api/v1/user_cert_data/`, {
              params: {
                id_card_num: this.id_card_num_birth_date,
                title_name: this.selected_title_name === 'อื่นๆ' ? this.title_name : this.selected_title_name,
                first_name: this.first_name,
                last_name: this.last_name,
                certificated_date: this.start_date,
                expire_date: this.end_date
              }
            }),
          ])
          this.card_certificated_status = false;
          this.card_certificated_status = true;
          // response.data.data.forEach((item) => {
          // item.certificated_date = (item.certificated_date);
          // item.expire_date = new (item.expire_date);
          // }) 
          this.certificated_status = response.data.data.cert_data;
          this.certificatedIdCardData = response.data.data.id_card_data 
          this.pdfDataCardNum = response.data.data.id_card_data_obj
          this.idCardProgress = response.data.data?.id_card_progress
          if(response.data.data.id_card_data) this.pdfData = `data:application/pdf;base64,${response.data.data.id_card_data}`
          else this.pdfData = null
          if (!this.certificatedIdCardData && Object.values(this.pdfDataCardNum).length) this.generatePDF()
          else this.pdfUrl = null
        } else {
          EventBus.$emit('alert-warning', 'ตรวจสอบข้อมูลอีกครั้ง !');
        }
      } catch (error) {
        EventBus.$emit('alert-error', 'ไม่พบข้อมูล ! กรุณาลองใหม่อีกครั้ง');
      } finally {
        this.updateUrlWithParams()
        this.loading = false;
      }
    },
    async getLisTitleName() {
      try {
        const baseURL = { baseURL: process.env.VUE_APP_API_URL, url: 'public/api/v1/get_titile_name' }
        const [lisTitleName] = await Promise.all([this.axios(baseURL)])
        this.list_title_name = lisTitleName.data.data
      } catch (error) {
        EventBus.$emit('alert-error', 'เกิดปัญหาระหว่างดึงข้อมูล กรุณาลองใหม่ภายหลัง')
        console.error(error);
      } finally {
        this.loading = false
      }

    },
    updateUrlWithParams() {
      const paramValue = this.id_card_num_birth_date;
      if (this.$route.path !== `/search_certificated/${paramValue}`){
        this.$router.replace({
          name: 'search_certificated',
          params: {
            id_card_num_birth_date: paramValue
          }
        });
      }
    },
    downloadCertificated() {
      console.log(this.id_card_num_birth_date)
    },
    previewPdf() {
    // ใส่ลิงก์ PDF ของคุณ
    this.pdfUrl = "/pdf/example.pdf";
    this.pdfDialog = true;
  }
  }
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

.search-exam-header-block {
  background: rgb(94, 174, 235);
  border-radius: 32px;
  height: fit-content;
}

.card-search {
  background: url("/imageBg.png"), 
  linear-gradient(354deg, rgb(147, 203, 246) 25.44%, rgba(27, 87, 126, 0.8) 161.68%);
  background-size:contain;
	background-position: bottom left;
	background-repeat: no-repeat;
  border-radius: 10px 45px !important;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2) !important;
  color: #ffffff !important;
}

.card-search-sm {
  border-radius: 20px !important;
}

.card-header {
  background:rgb(94, 174, 235);
}

.text-white{
  font-family: "Noto Sans Thai", sans-serif;
  color: white;
}

.search-exam-header {
  font-family: "Noto Sans Thai", sans-serif;
  color: white;
  font-size: 22px;
}

.card-text {
  background: rgb(254, 255, 255);
  border: 3px solid rgb(94, 174, 235) !important;
  border-top: none !important;
}

.input-card-search {
  border-radius: 10px !important;
  background-color: white;
}

.input-box-card-search>.v-input__control>.v-input__slot {
  padding-left: 3% !important;
  padding-right: 1% !important;
}

.search-btn {
  color: white !important;
  border-radius: 32px !important;
}

.pass-exam-calendar {
  font-family: 'Noto Sans Thai', sans-serif;
}

.certificated-image {
  border-radius: 10px;
  border: 3px double rgb(94, 174, 235) !important;
  height: 200px;
}

.head-topic-certificated {
  font-size: 16px;
}

.topic-certificated {
  font-weight: bold;
  font-size: 16px;
}

.card-pdf-v2.v-card {
  font-family: "Sarabun", sans-serif;
  position: relative;
  background-color: #D3FF31;
  border: 2px solid #0F3A29;
  border-radius: 30px;
  padding: 18px 12px 18px 18px;
  font-size: 9px;
  font-weight: 400;
}

.card-pdf-bg{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.27;
  z-index: 0;
}

.flex-layout{
  display: flex;
  /* justify-content: center; */
  /* align-items: center; */
}

.flex-layout-between{
  justify-content: space-between;
}                   

.flex-layout-column {
  /* transform: scale(1.5); */
  flex-flow: column;
  /* padding: 3% 0% 3% 5% */
}

.pdf-v2-sec1  p{
  display: flex;
  align-items: center;
  color: #001F5F;
  margin-bottom: 3px;
  gap: 6px;
}
.pdf-v2-sec1  p span{
  color: #0D2500;
  font-size: 8px;
  font-weight: 500;
}

.pdf-v2-sec1{
  margin-bottom: 100px;
}

.pdf-v2-sec1 .pdf-no{
  justify-content: end;
  /* padding-right: 8%; */
  margin-bottom: 7px;
}

.pdf-v2-sec1.v-card{
  padding-top: 15px;
}

.sec1-description {
  position: relative;
  z-index: 1;
}

.pdf-v2-sec2 p{
  text-align: start;
  text-indent: 28px;
  word-break: break-word;
  margin-bottom: 0;
}

.sec2-description{
  text-align: center;
  margin-bottom: 20px;
}
  
.flex-layout-licence {
    color: #000000 !important; 
    margin-top: 7px;
    padding-left: 11% !important;
}

.flex-layout-licence-signature {
    margin-left: 67px;
    width: 25%;
    height: 100%;
}

.flex-layout-licence-name {
    padding-left: 32% !important;
    font-weight: 300;
    color: #000000 !important;
    font-size: 7px;
}

.flex-layout-licence-position {
    padding-left: 10% !important;
    color: #000000 !important;
    font-size: 8px;
}

.flex-layout-licence-authority {
    padding-left: 38% !important;
}

.card-row {
  display: flex;
  gap: 150px;        /* spacing between front + back */
  justify-content: center;
  align-items: flex-start;
}

.card-wrapper {
  width: calc(317px * 1.5);
  height: calc(204px * 1.5);
  overflow: hidden;
  position: relative;
}

.card-scale {
  transform: scale(1.5);
  transform-origin: top left;
  width: 317px;
  height: 204px;
}

.dialog-pdf {
  font-family: "Sarabun", sans-serif;
}

.back-card .sec1-description {
  display: flex;
  justify-content: center;   /* center horizontally */
  align-items: center;        /* center vertically */
  text-align: justify;        /* justify paragraphs */
}

/* Force justify alignment edge to edge */
.back-card p {
  width: 100%;
  text-align: justify;          
  text-align-last: justify;     
  text-justify: distribute;     
  letter-spacing: 0;            
  line-height: 1.4;             
  word-break: keep-all;
}

/* Center image inside the first <p> */
.back-card p img {
  display: block;
  margin: 0 auto;  /* centers image */
}

/* Optional: control paragraph width for nicer edge alignment */
.back-card .v-col {
  width: 100%;
}

@media (max-width: 1200px) {
  .card-row {
    flex-direction: column;
    align-items: center;
    gap: 50px;   
  }

  .card-wrapper {
    width: 317px;
    height: 204px;
    overflow: visible;
  }

  .card-scale {
    transform: scale(1); /* remove scale to avoid cropping */
  }
}

/* ----------------------------------
   MOBILE (<600px)
   (same behaviors as tablet)
----------------------------------- */
@media (max-width: 600px) {
  .card-row {
    flex-direction: column;
    align-items: center;
    gap: 20px; 
  }
}
</style>
